module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("notifications.title-mail")))]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": ("" + _vm.mailTitle)
    },
    model: {
      value: (_vm.emailNotification),
      callback: function($$v) {
        _vm.emailNotification = $$v
      },
      expression: "emailNotification"
    }
  })], 1), _vm._v(" "), _c('v-card-text', [_c('h2', {
    staticClass: "pl-2"
  }, [_vm._v(_vm._s(_vm.$t("notifications.title-langage")))]), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-0",
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.items,
      "label": _vm.emailLanguage,
      "item-text": "disp",
      "item-value": "code",
      "single-line": "",
      "bottom": "",
      "auto": ""
    },
    model: {
      value: (_vm.emailLanguage),
      callback: function($$v) {
        _vm.emailLanguage = $$v
      },
      expression: "emailLanguage"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../src/~/vue-loader/lib/template-compiler?{"id":"data-v-6eb098b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../src/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotificationsMail.vue
// module id = 1937
// module chunks = 0